import { useCookieStore } from "@/client/stores/cookie";

export const useCookieConsent = () => {
  const { consent, isModalOpen, setModalOpen } = useCookieStore();

  return {
    consent,
    isModalOpen,
    setModalOpen,
    hasConsent: consent !== null,
    hasAnalyticsConsent: consent?.analytics ?? false,
    hasMarketingConsent: consent?.marketing ?? false,
    hasNecessaryConsent: consent?.necessary ?? true, // Necessary cookies are always considered consented
  };
}; 